module.exports = __webpack_public_path__ + "1.0/img/title-pre-buy.be8442f9.png";